import React from "react";
import { Tooltip } from "@mui/material";
import Icon from "../../../components/ui/Icon";
import { ExtractionError } from "../../../model/ExtractionError";
import { getTranslationStatusColor } from "../../../utils/ApiUtils/TranslationHelper";

export function StatusCell({ value, error }: { value: string; error?: ExtractionError | null }) {
  const textColor = getTranslationStatusColor(value);

  console.log("Status:", value);
  console.log("Error object:", error);
  console.log("Error exists?", !!error);
  console.log("Error message:", error?.errorMessage);

  const handleDownload = (e: React.MouseEvent) => {
    e.stopPropagation();
    const blob = new Blob([JSON.stringify(error, null, 2)], { type: "application/json" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "error.json";
    link.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className="flex items-center gap-1">
      <Tooltip title={value}>
        <span className={`font-display font-bold ${textColor}`}>{value}</span>
      </Tooltip>
      {error && (
        <Tooltip
          title={<span style={{ whiteSpace: "pre-line" }}>{error.errorMessage}</span>}
          enterTouchDelay={0}
          leaveTouchDelay={5000}
        >
          <span
            className="inline-flex items-center text-red-500 cursor-pointer"
            onClick={handleDownload}
            style={{ userSelect: "none" }}
            title="Download error JSON"
          >
            <Icon icon="triangleExclamation" />
          </span>
        </Tooltip>
      )}
    </div>
  );
}
